var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "22px",
    viewBox: "0 0 14 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slider-right-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-slider-right-arrow",
    transform: "translate(-8.000000, 1.000000)",
    strokeWidth: 3,
    stroke: "#6F82BF"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-6",
    transform: "translate(9.936292, 9.936291) rotate(45.000000) translate(-9.936292, -9.936291) ",
    points: "3.3918746 3.39187389 16.4807094 3.39187389 16.4807094 16.4807087"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d98145e2ab287ecc5b4ffdddb1d9d8ee.svg";
export { ForwardRef as ReactComponent };